import { useApi } from '../../utils/use-api';

const api = useApi();

export const organisationService = {
  getContactDetails: (): Promise<ContactDetails> => api.jsonrpc({
    url: 'organisation:getContactDetails'
  }),
}
